/**
 * RFC 7807 problem `type` URIs for email business errors. Match on these
 * via `getApiError(error)` instead of parsing `detail`. Mirrors the backend
 * `App\Email\Enum\EmailErrorType`.
 */
export const EmailErrorType = {
  AllRecipientsInvalidEmail: '/errors/email-all-recipients-invalid-email'
} as const

export type EmailErrorType =
  (typeof EmailErrorType)[keyof typeof EmailErrorType]

/**
 * RFC 7807 problem `type` URIs for action business errors. Match on these
 * via `getApiError(error)` instead of parsing `detail`. Mirrors the backend
 * `App\Action\Enum\ActionErrorType`.
 */
export const ActionErrorType = {
  AttachmentNotAllowed: '/errors/action-attachment-not-allowed',
  LimitExceeded: '/errors/action-limit-exceeded',
  RecipientInvalid: '/errors/action-recipient-invalid',
  RecipientInvalidEmail: '/errors/action-recipient-invalid-email',
  RecipientNotAllowed: '/errors/action-recipient-not-allowed',
  RecipientOutsideOrderCompany:
    '/errors/action-recipient-outside-order-company',
  TypeNotCompletable: '/errors/action-type-not-completable',
  TypeContextMismatch: '/errors/action-type-context-mismatch'
} as const

export type ActionErrorType =
  (typeof ActionErrorType)[keyof typeof ActionErrorType]
